import styled, {css} from "styled-components";

import React from "react";
import {observer} from "mobx-react-lite";
import {MinusCircleIcon} from "../../assets/svg/minus-circle.icon";
import {PlusCircleIcon} from "../../assets/svg/plus-circle.icon";

const ButtonBox = styled.div<{$disabled: boolean}>`
    display: flex;
    align-items: center;
    color: ${props => props.theme.colors.primary};
    ${
        props => props.$disabled 
                ? css`
                    cursor: not-allowed;
                    opacity: 0.5;
                    color: ${props => props.theme.colors.medium};
                    visibility: hidden;
                `
                : css`
                    cursor: pointer;
                    opacity: 1;
                `
    }
`


interface QuantityChangeButtonComponentProps {
    icon: string | React.ReactElement;
    disabled: boolean;
    onClick: () => void;
    className?: string;
}

const QuantityChangeButtonComponent: React.FC<QuantityChangeButtonComponentProps> = observer((props) => {
    return (
        <ButtonBox className={props.className}
                   onClick={props.onClick}
                   $disabled={props.disabled}>
            {props.icon}
        </ButtonBox>
    );
})

interface QuantityChangeConcreteButtonComponentProps extends Omit<QuantityChangeButtonComponentProps, 'icon'> {
}

export const QuantityDecrementButtonComponent: React.FC<QuantityChangeConcreteButtonComponentProps> = observer((props) => {
    return (
        <QuantityChangeButtonComponent {...props} icon={(<MinusCircleIcon size={1.3}/>)}/>
    );
})


export const QuantityIncrementButtonComponent: React.FC<QuantityChangeConcreteButtonComponentProps> = observer((props) => {

    return (
        <QuantityChangeButtonComponent {...props} icon={(<PlusCircleIcon size={1.3}/>)}/>
    );

})
